import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 11px 16px;
  background: #f6f8f7;
  border-top: 1px solid ${(p) => p.theme.tokens.colors.line};
  border-bottom: 1px solid ${(p) => p.theme.tokens.colors.line};
  position: sticky;
  top: 0;
  z-index: 3;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Badge = styled.div<{ $done: boolean }>`
  width: 25px;
  height: 25px;
  border-radius: 13px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 11.5px;
  font-weight: 900;
  background: ${(p) => (p.$done ? p.theme.tokens.colors.green : p.theme.tokens.gradients.header)};
  box-shadow: ${(p) => (p.$done ? "0 3px 9px rgba(22,184,119,0.32)" : "0 3px 9px rgba(14,122,102,0.28)")};
`;

export const Texts = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.div`
  font-weight: 900;
  font-size: 14.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
  letter-spacing: -0.2px;
`;

export const Subtitle = styled.div`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 1px;
`;

export const RequiredTag = styled.span<{ $done: boolean }>`
  font-size: ${(p) => (p.$done ? "10px" : "9.5px")};
  font-weight: 900;
  letter-spacing: 0.2px;
  padding: 3px 9px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${(p) => (p.$done ? "#11935F" : "#8A6A1F")};
  background: ${(p) => (p.$done ? "#E3F6EE" : "#FBEFD6")};
`;

export const OptionalTag = styled.span`
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0.3px;
  padding: 3px 9px;
  border-radius: 999px;
  color: #9aa8a3;
  background: ${(p) => p.theme.tokens.colors.line};
`;
